<template>
  <div class="schedule">
    <MainHeader>
      {{$ml.get('Fertilizer Schedule')}}
    </MainHeader>
    <div class="items">
      <StageItem v-for="item in $root.data.schedule.data" :data="item"/>
    </div>
  </div>
</template>

<script>
import MainHeader from './../components/common/MainHeader';
import StageItem from './../components/schedule/StageItem';

export default {
  components: {
    MainHeader,
    StageItem,
  }
}
</script>

<style lang="scss" scoped>

.schedule {
  .head-line {
    margin-bottom: 10px;
  }
}

</style>